import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSk: CultureInfo = {
  name: 'sk',
  displayName: 'Slovak',
  iso3LanguageCode: 'slk',
  iso2LanguageCode: 'sk',
  ietfLanguageTag: 'sk',
  parent: null
};
